"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuditActionEnum;
(function (AuditActionEnum) {
    AuditActionEnum["CREATE"] = "CREATE";
    AuditActionEnum["UPDATE"] = "UPDATE";
    AuditActionEnum["DELETE"] = "DELETE";
    AuditActionEnum["PUBLISH"] = "PUBLISH";
    AuditActionEnum["IMPORT"] = "IMPORT";
})(AuditActionEnum = exports.AuditActionEnum || (exports.AuditActionEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXVkaXQtYWN0aW9uLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW51bXMvYXVkaXQtYWN0aW9uLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxJQUFZLGVBTVg7QUFORCxXQUFZLGVBQWU7SUFDekIsb0NBQWlCLENBQUE7SUFDakIsb0NBQWlCLENBQUE7SUFDakIsb0NBQWlCLENBQUE7SUFDakIsc0NBQW1CLENBQUE7SUFDbkIsb0NBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQU5XLGVBQWUsR0FBZix1QkFBZSxLQUFmLHVCQUFlLFFBTTFCIn0=